<app-empty-state
    i18n-title
    title="Let's pick up where we left off"
    type="noData"
>
    <div class="questionnaire-info-container">
        <ul>
            <li>You may complete any questions that have not been answered yet.</li>
            <li>
                If you previously only completed the Condensed version of the questionnaire, you may also complete the Full version of the
                questionnaire.
            </li>
            <li>You may update your answers if anything in your organization or environment has changed.</li>
            <li>
                If you have submitted your answers and they have been reviewed by the Cyber Intelligence Fusion Cell, you can make any
                changes that have been requested.
            </li>
        </ul>
        <p>
            Providing full answers to every question allows the MDR Service to tailor the service to your environment and provide the best
            security coverage.
        </p>
    </div>
    <br />
    <button
        (click)="resumeQuestionnaire(true)"
        [routerLink]="'/cq/questionnaire'"
        class="m-t-24"
        color="primary"
        i18n
        id="start-questionnaire-button"
        mat-flat-button
    >
        Resume
    </button>
</app-empty-state>
